import { render, staticRenderFns } from "./ServersDialog.vue?vue&type=template&id=88fee36e&"
import script from "./ServersDialog.vue?vue&type=script&lang=ts&"
export * from "./ServersDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports